<template>
	<div id="company-card-main">
		<template v-if="activeTab === 0">
			<bread-crumbs
				:title="$t('Roles.Roles')"
				:subTitle="$t('general.SubtitleRol')"
				:sizeTitle="30"
				:lineHeightTitle="37"
				:sizeSubTitle="15"
				:lineHeightSubTitle="18"
			></bread-crumbs>
			<div class="vx-col w-full mb-4">
				<vs-button type="filled" class="g-btn-customize p-0" @click.prevent="activeTab = 1">
					{{ $t("Crud.Create") + " " + $t("New") + " " + $t("Role") }}
				</vs-button>
			</div>
		</template>
		<div :class="activeTab === 0 ? 'vx-card p-4' : ''">
			<div v-if="activeTab === 0" class="tab-text">
				<roles-list-view @selectedRoleEmit="selectedRole"></roles-list-view>
			</div>
			<div v-else-if="activeTab === 1" class="tab-text">
				<roles-form
					v-if="roleCreatePermission && role.id === 0 && currenRole === 'admin'"
					:role="role"
					@clearRoleEmit="clearRole"
					@updateRolesEmit="updateRoles"
					@cancelEditEmit="cancelEdit"
					@changeActiveTabEmit="valueRoleEmit"
				/>
				<roles-form
					v-else-if="rolUpdatePermission && role.id > 0"
					:role="role"
					:editable="editable"
					@clearRoleEmit="clearRole"
					@updateRolesEmit="updateRoles"
					@cancelEditEmit="cancelEdit"
					@changeActiveTabEmit="valueRoleEmit"
				/>
				<not-permission v-else></not-permission>
			</div>
		</div>
	</div>
</template>

<script>
import RolesForm from "./RolesForm.vue";
import RolesListView from "./RolesListView.vue";
import Role from "@/models/Role.js";
import NotPermission from "@/views/pages/NotPermission.vue";

export default {
	name: "Roles",
	data() {
		return {
			role: new Role({}),
			activeTab: 0,
			editable: false,
			currenRole: "editor",
		};
	},
	components: {
		RolesForm,
		RolesListView,
		NotPermission,
	},
	computed: {
		roleCreatePermission() {
			return this.$store.getters.checkPermission("ROLE_C");
		},
		rolUpdatePermission() {
			return this.$store.getters.checkPermission("ROLE_U");
		},
		roleReadPermission() {
			return this.$store.getters.checkPermission("ROLE_R");
		},
		roleDeletePermission() {
			return this.$store.getters.checkPermission("ROLE_D");
		},
	},
	methods: {
		// Limpiar rol
		clearRole() {
			this.role = new Role({});
		},
		// Actualizar roles en el state
		updateRoles() {
			this.$vs.loading();
			this.$store
				.dispatch("moduleRoles/getRoles")
				.then((res) => {
					this.$vs.loading.close();
					this.updatePermissions();
				})
				.catch((err) => {
					this.$vs.loading.close();
					this.$vs.notify({
						color: "danger",
						title: this.$t("Roles.GetRoles.TitleError"),
						text: this.$t("Roles.GetRoles.TextError"),
					});
					throw new Error(err);
				});
		},
		// Actualizar los permisos en el state
		updatePermissions() {
			this.$vs.loading();
			this.$store
				.dispatch("moduleRoles/getRolePermission")
				.then((res) => {
					this.$vs.loading.close();
				})
				.catch((err) => {
					this.$vs.loading.close();
					this.$vs.notify({
						color: "danger",
						title: this.$t("Roles.GetRoles.TitleError"),
						text: this.$t("Roles.GetRoles.TextError"),
					});
					throw new Error(err);
				});
		},
		// Rol seleccionado en el componente RolList
		selectedRole(role) {
			this.role = new Role(role);
			this.activeTab = 1;
			this.editable = true;
		},
		// Cancelar edición
		cancelEdit() {
			this.editable = false;
			this.activeTab = 0;
		},
		valueRoleEmit(val) {
			this.activeTab = val;
			if (this.activeTab === 0) {
				this.role = new Role({});
			}
		},
	},
	watch: {
		activeTab(val) {
			if (val === 0) {
				this.role = new Role({});
				this.editable = false;
			}
		},
	},
	created() {
		this.updateRoles();
		this.currenRole = this.$store.state.AppActiveUser.userRole;
	},
};
</script>
